function Banner({title, image}) {
    return (
        <section id="banniere" className="relative bg-primary-600 w-full pt-[6.25rem] h-[21.875rem] overflow-hidden">
            <img data-enter src={image} alt={title} className="object-cover object-center w-full h-full" />
        </section>
    );
}

export default Banner;